/**
 * Core types for Kript
 */
/** Error codes */
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["INVALID_KEY"] = "INVALID_KEY";
    ErrorCode["INVALID_PASSPHRASE"] = "INVALID_PASSPHRASE";
    ErrorCode["INVALID_MESSAGE"] = "INVALID_MESSAGE";
    ErrorCode["INVALID_SIGNATURE"] = "INVALID_SIGNATURE";
    ErrorCode["KEY_NOT_FOUND"] = "KEY_NOT_FOUND";
    ErrorCode["KEY_EXPIRED"] = "KEY_EXPIRED";
    ErrorCode["KEY_REVOKED"] = "KEY_REVOKED";
    ErrorCode["ENCRYPTION_FAILED"] = "ENCRYPTION_FAILED";
    ErrorCode["DECRYPTION_FAILED"] = "DECRYPTION_FAILED";
    ErrorCode["SIGNING_FAILED"] = "SIGNING_FAILED";
    ErrorCode["VERIFICATION_FAILED"] = "VERIFICATION_FAILED";
    ErrorCode["STORAGE_ERROR"] = "STORAGE_ERROR";
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ErrorCode["KEYRING_LOCKED"] = "KEYRING_LOCKED";
    ErrorCode["KEYRING_NOT_ENCRYPTED"] = "KEYRING_NOT_ENCRYPTED";
})(ErrorCode || (ErrorCode = {}));
/** Custom error class for PGP operations */
export class PGPError extends Error {
    code;
    cause;
    constructor(code, message, cause) {
        super(message);
        this.code = code;
        this.cause = cause;
        this.name = 'PGPError';
    }
}
//# sourceMappingURL=types.js.map